import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import { Button, Form, Icon, Popup } from 'semantic-ui-react';
import { InputField, Dropdown } from 'react-semantic-redux-form';

class AppearanceSearchForm extends Component {

    render() {
        const { handleSubmit, types, slots } = this.props;

        const tagOptions = ['Craftable', 'Costume', 'Lootable', 'Purchasable', 'Quest Reward'].map( c => { return {
            key: c,
            value: c,
            text: c,
        }});

        const typeOptions = types.map( t => { return {
            key: t,
            value: t,
            text: t
        }});

        const slotOptions = slots.map( s => { return {
            key: s,
            value: s,
            text: s
        }});

        return (
            <Form onSubmit={handleSubmit}>
                <Form.Group>
                    <Form.Field width={16}>
                        <label>
                        Name&nbsp;
                        <Popup trigger={<Icon circular name="info" color='grey' size='small' />} content="You can surround your search with quotes to perfom an exact search" />
                        </label>
                        <Field name="text" component={InputField} type="text" />
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                    <Form.Field>
                        <label>Source</label>
                        <Field name="tags" component={Dropdown} multiple search selection options={tagOptions}/>
                    </Form.Field>
                    <Form.Field>
                        <label>Slot</label>
                        <Field name="slots" component={Dropdown} multiple search selection options={slotOptions}/>
                    </Form.Field>
                    <Form.Field>
                        <label>Type</label>
                        <Field name="types" component={Dropdown} multiple search selection options={typeOptions}/>
                    </Form.Field>
                </Form.Group>
                <Form.Field>
                    <Button content='Search' icon='search' labelPosition='right' primary type='submit'/>
                </Form.Field>
            </Form>
        )
      }

}

AppearanceSearchForm = reduxForm({
    // a unique name for the form
    form: 'appearance_search'
})(AppearanceSearchForm);

// You have to connect() to any reducers that you wish to connect to yourself
AppearanceSearchForm = connect(
    state => ({
        initialValues: state.appearanceSearch.parameters,
        slots: state.appearanceSlots.slots,
        types: state.appearanceTypes.types,
    }),
)(AppearanceSearchForm)

export default AppearanceSearchForm;


// WEBPACK FOOTER //
// ./src/appearances/index/AppearanceSearchForm.jsx